module.exports = __webpack_public_path__ + "static/media/life-redemption-main-graphic.6d302596.png";